import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import {
  Plus, Truck, Package, Barcode, Warning, Check, ClipboardText, FileText,
  Eye, X, CaretRight, ListChecks, Lock, Prohibit, Pause, Trash, DownloadSimple,
  Camera, ImageSquare, Printer, Lightning, Gauge, CalendarCheck,
} from '@phosphor-icons/react';

import { SumItem, SummaryBar, STATUS_META, NEXT_STATUS } from '../_shared';

export const StagingTab = ({ detail }) => {
  const remaining = (detail.allocations || []).flatMap(a =>
    a.items.map(i => ({
      order_number: a.order_number,
      sku_code: i.sku_code,
      qty_allocated: i.qty_allocated,
      qty_loaded: i.qty_loaded,
      short: i.qty_allocated - i.qty_loaded,
    }))
  );
  const stagedUnits = remaining.reduce((s, r) => s + r.qty_loaded, 0);
  const totalAllocated = remaining.reduce((s, r) => s + r.qty_allocated, 0);
  return (
    <div className="mt-4 space-y-3" data-testid="staging-tab">
      <h3 className="text-sm font-bold uppercase tracking-widest text-foreground">Picking & Staging</h3>
      <div className="grid grid-cols-3 gap-3">
        <SumItem label="Total units to pick" value={totalAllocated} />
        <SumItem label="Picked & loaded" value={stagedUnits} accent="emerald" />
        <SumItem label="Outstanding" value={totalAllocated - stagedUnits} accent={totalAllocated - stagedUnits > 0 ? 'rose' : 'slate'} />
      </div>
      <p className="text-xs text-muted-foreground italic">
        Pick waves are generated from the allocated orders — use the Picking module to execute waves,
        then scan SKUs onto the container in the Loading tab.
      </p>
      <div className="border border-border">
        <table className="w-full table-dense">
          <thead>
            <tr><th>Order</th><th>SKU</th><th className="text-right">Short</th><th className="text-right">Status</th></tr>
          </thead>
          <tbody>
            {remaining.map((r, i) => (
              <tr key={i}>
                <td className="font-mono text-xs text-brand">{r.order_number}</td>
                <td className="font-mono font-bold">{r.sku_code}</td>
                <td className="text-right font-mono">{r.short}</td>
                <td className="text-right">
                  {r.short === 0
                    ? <span className="text-emerald-700 font-bold text-xs">Ready</span>
                    : <span className="text-amber-700 text-xs">Pending</span>}
                </td>
              </tr>
            ))}
            {remaining.length === 0 && <tr><td colSpan={4} className="text-center py-6 text-muted-foreground">No allocations.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

